import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { MSpinner } from "components/Shared";
import MCaseView from "containers/Homeowner/MCaseView";
import {
  ACE_PDR_CONVERT_TO_APPRAISAL_ANY_STATUS,
  ACE_PDR_CONVERT_TO_APPRAISAL_COMPLETED
} from "typeConstants/rights";

const BrokerCase = (props) => {
  const { location: { state }, profile } = props;
  const [controlNumber, setControlNumber] = useState(0);

  useEffect(() => {
    if (state && state.controlNumber !== controlNumber) {
      setControlNumber(state.controlNumber);
    }
  }, [state]);

  const getSections = () => {
    let sections = [];
    sections.push({
      title: "Order Information",
      id: "BrokerCaseHeader",
      formStatus: "clean",
    });
    sections.push({
      title: "History",
      id: "History",
      formStatus: "clean",
    });
    sections.push({
      title: "File Manager",
      id: "Files",
    });
    sections.push({
      title: "Photos",
      id: "Photos",
      formStatus: "clean",
    });
    if (profile.rights.includes(ACE_PDR_CONVERT_TO_APPRAISAL_ANY_STATUS)
        || profile.rights.includes(ACE_PDR_CONVERT_TO_APPRAISAL_COMPLETED)){
      sections.push({
        title: "Case Actions",
        id: "Validation",
      });
    }
    return sections;
  };

  if (!controlNumber) {
    return (<MSpinner />);
  }
  return (
    <MCaseView
      externalFormSet={getSections()}
      controlNumberOverride={controlNumber}
      firstChildInitialSize={"40%"}
    />
  );

};

BrokerCase.propTypes = {
  location: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    profile: state.user.profile
  };
};

export default connect(mapStateToProps)(BrokerCase);
